import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { logout } from '../../utils/logout';
import { resolveAssessmentApiBaseUrl } from './assessmentApiConfig';

/**
 * Assessment-only HTTP client — base URL follows current host/IP on every request.
 */
const assessmentApi = axios.create({
  baseURL: resolveAssessmentApiBaseUrl(),
});

assessmentApi.interceptors.request.use((config) => {
  config.baseURL = resolveAssessmentApiBaseUrl();

  const token = localStorage.getItem('token');

  if (token) {
    try {
      const decoded = jwtDecode(token);
      const now = Math.floor(Date.now() / 1000);

      if (decoded.exp && decoded.exp < now) {
        logout();
        return Promise.reject(new Error('Token expired'));
      }

      config.headers.Authorization = `Bearer ${token}`;
    } catch (err) {
      logout();
      return Promise.reject(err);
    }
  }

  return config;
});

assessmentApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.code === 'ERR_CANCELED' || error?.name === 'CanceledError') {
      return Promise.reject(error);
    }

    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      originalRequest &&
      !originalRequest.url?.includes('/auth/login')
    ) {
      logout();
    }

    return Promise.reject(error);
  }
);

export default assessmentApi;
